import {ShowAlertPayload} from "interfaces";

export const alertMessages: Record<
  | "login"
  | "update-photo"
  | "forgot-password"
  | "change-password"
  | "update-profile",
  ShowAlertPayload
> = {
  login: {
    type: "success",
    title: "Bienvenido",
    message: "Iniciaste sesión correctamente",
  },

  "forgot-password": {
    type: "success",
    title: "Te hemos enviado un correo",
    message: "Para restablecer tu contraseña, ve a tu correo y abre el enlace",
  },
  "change-password": {
    type: "success",
    title: "Contraseña actualizada",
    message: "Ya puedes usar tu nueva contraseña para ingresar",
  },
  "update-profile": {
    type: "success",
    title: "Perfil actualizado con éxito",
  },
  "update-photo": {
    type: "success",
    title: "Tu foto de perfil ha sido actualizada",
  },
};
